__turbopack_context__.v({
  "verifiedBlue": "verified-badge-module__y3BE2a__verifiedBlue",
  "verifiedGovernment": "verified-badge-module__y3BE2a__verifiedGovernment",
  "verifiedOld": "verified-badge-module__y3BE2a__verifiedOld",
});
